import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
const AddUser = () => {
  const formRef = useRef(null);
  let [iniVal, setIniVal] = useState({
    user_name: "",
    email: "",
    mobile: "",
    password: "",
    cpassword: "",
  });
  const [showPassowrd, setShowPassowrd] = useState(false);
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  // console.log("server url", SERVER_URL)
  const users_id = Cookies.get("users_id");
  // console.log(users_id)
  const token = Cookies.get("token");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setIniVal(() => {
      return {
        ...iniVal,
        [name]: value,
      };
    });
  };
  function reset() {
    setIniVal({
      user_name: "",
      email: "",
      mobile: "",
      password: "",
      cpassword: "",
    });
  }
  const handleSubmit = async (e) => {
    e.preventDefault();

    const { user_name, email, password, cpassword, mobile } = iniVal;

    if (password !== cpassword) {
      toast.error("Password and C-Password do not match");
      return;
    }

    const response = await fetch(SERVER_URL + `/api/users/add-user`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        user_name,
        email,
        password,
        mobile,
      }),
    });

    const data = await response.json();
    if (data.status === 200) {
      toast.success(data.message);
      reset();
    } else {
      toast.error(data.message);
    }
  };
  function hideShowPassword() {
    let password = document.getElementById("password");
    let confirm_password = document.getElementById("cpassword");
    if (showPassowrd) {
      password.type = "password";
      confirm_password.type = "password";
      setShowPassowrd(false);
    } else {
      password.type = "text";
      confirm_password.type = "text";
      setShowPassowrd(true);
    }
  }
  return (
    <>
      <div className="col-12 grid-margin">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Add User</h4>
            <form className="form-sample" onSubmit={handleSubmit}>
              {/* <p className="card-description">Personal info</p> */}
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="name">Name</label>

                    <input
                      type="text"
                      className="form-control"
                      name="user_name"
                      onChange={handleChange}
                      id="name"
                      placeholder="Name"
                      value={iniVal.user_name}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="email">Email</label>

                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      onChange={handleChange}
                      id="email"
                      placeholder="Email"
                      value={iniVal.email}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="mobile">Mob. Number</label>

                    <input
                      type="text"
                      className="form-control"
                      name="mobile"
                      onChange={handleChange}
                      id="mobile"
                      placeholder="Mob-Number"
                      value={iniVal.mobile}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="password">Password</label>

                    <input
                      type="password"
                      className="form-control"
                      name="password"
                      onChange={handleChange}
                      id="password"
                      placeholder="Password"
                      value={iniVal.password}
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="cpassword">Confirm Password</label>
                    <input
                      type="password"
                      className="form-control"
                      name="cpassword"
                      onChange={handleChange}
                      id="cpassword"
                      placeholder="Confirm Password"
                      value={iniVal.cpassword}
                      required
                    />
                  </div>
                </div>
                <div className="form-check ml-3">
                  <label className="form-check-label">
                    <input
                      type="checkbox"
                      className="form-check"
                      onClick={() => hideShowPassword()}
                    />
                    <i className="input-helper"></i> Show Password
                  </label>
                </div>
              </div>
              <button className="btn btn-primary mr-2 mt-3" type="submit">
                Add User
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddUser;
